import $ from 'jquery';
import { onStateChange } from '../../core/stent/subscribe';
export const init = async function(machine) {
    onStateChange(machine, function updateCartItemCountInHeader(state) {
        if (state.name !== 'Ready') {
            return;
        }
        if (state.contents.item_count > 0) {
            $('.js-cart-item-count').attr('data-item-count', state.contents.item_count);
        } else {
            $('.js-cart-item-count').attr('data-item-count', '');
        }
    });
};
